var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationDashboard'),_vm._v(" "),_c('div',{staticClass:"dashboard-layout"},[_c('nuxt',{staticClass:"dashboard-layout-container"})],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('BikeAddModal'),_vm._v(" "),_c('EditBikeModal'),_vm._v(" "),_c('CreatePasswordModal'),_vm._v(" "),_c('BuildBadge')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }